<template>
  <span v-if="!task.discarded">
    <i class="material-icons pointer ml-1" data-toggle="modal" :data-target="'#tagsModal' + task.id">label_outline</i>
    <div class="modal fade" :id="'tagsModal' + task.id">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t("tags.plural") }}</h5>
            <button type="button" class="btn btn-inverse pull-right" data-dismiss="modal" @click="saveTags()">Done</button>
          </div>
          <div class="modal-body">
            <div class="input-group mb-3">
              <input type="text" class="form-control" v-model="newTag" v-on:keyup.enter="addTag" :placeholder="$t('tags.new')">
              <div class="input-group-append">
                <button class="btn btn-primary" type="button" @click="addTag">Add {{ $t("tags.singular") }}</button>
              </div>
            </div>
            
            <ul class="mt-2 list-group">
              <li v-for="tag in allTags" class="list-group-item pointer" @click="toggleTag(tag.name)">
                <span>
                  <i v-if="tagAttached(tag)" class="material-icons bottom-align text-success">label</i>
                  <i v-else class="material-icons bottom-align text-success">label_outline</i>
                  <span class="text-muted">{{tag.name}}</span>
                </span>
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="saveTags()">Done</button>
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
var firstBy = require('thenby');
import api from "api";

export default {
  data() {
    return {
      selectedTags: this.task.formatted_tag_list.split(','),
      newTag: '',
      allTags: this.$store.state.active_tags.sort(firstBy("active_sort"))
    };
  },
  props: {
    task: {
      type: Object
    }
  },
  methods: {
    saveTags(){
      var router = this.$router

      var message = this.$t('tags.plural') + ' updated for ' + this.task.title
      var task = this.task
      
      api.updateTask(this.task.id, { title: this.task.title, tags: this.selectedTags }).then(response => {
        $('#tagsModal' + this.task.id).modal('hide');
        $('body').removeClass('modal-open');
        $(".modal-backdrop").hide();

        if(this.selectedTags.length > 0){
          this.$router.push({ name: 'tags', params: { tag_name: this.selectedTags[this.selectedTags.length - 1] } }) 
        } else {
          router.push({ name: 'todo', params: { task_id: task.id } })
        }
      });
    },
    toggleTag(tag_name){
      if(this.selectedTags.includes(tag_name)){
        // Remove Tag
        var index = this.selectedTags.indexOf(tag_name)
        this.selectedTags.splice(index, 1);

        store.commit('removeFromSortedGroup', {
          taskId: this.task.id,
          groupName: 'tagName' + tag_name
        })
      } else {
        // Add Tag
        this.selectedTags.push(tag_name)

        store.commit('addToSortedGroup', {
          taskId: this.task.id,
          groupName: 'tagName' + tag_name
        })
      }
    },
    tagAttached(tag){
      return this.selectedTags.includes(tag.name)
    },
    addTag(){
      var tag_name = this.newTag.trim().replace(/\//g, "-")
      this.$store.state.active_tags.push({name: tag_name})
      this.toggleTag(tag_name)
      api.updateTask(this.task.id, { title: this.task.title, tags: this.selectedTags }).then(response => {
        this.newTag = ''
      });
    },
  }
}
</script>
